import React, { useContext, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import gql from 'graphql-tag'
import { useQuery } from 'urql'
import { lensPath, pipe, set } from 'ramda'
import RoutingContext from '../../../context/RoutingContext'
import PageNavContainer from '../../../state/PageNavContainer'
import OldAppHeader from '../../AppModule/App/OldAppHeader'
import HubEpworthQuizResultsPage from './HubEpworthQuizResultsPage'
import LoadOverlay from '../../shared/LoadOverlay'

// -----------------------------------------------------------------------------
// Query
// -----------------------------------------------------------------------------

const CurrentEnrolmentForLatestEpworthResult = gql`
  query latestEpworthResult {
    currentEnrolment {
      id
      latestEpworthResult: latestQuestionnaireResult(key: "epworth") {
        id
        maximumScore
        result
        score
      }
    }
  }
`

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `hub-about-therapy`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const setPagesHubSleepCoachesCardLinkUrl = set(
  lensPath([`page`, `content`, `therapyCard`, `link`, `url`])
)

const injectRouting = (routing, content) =>
  pipe(setPagesHubSleepCoachesCardLinkUrl(routing.chatMessagesPath))(content)

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubDbasQuizResultsModule = () => {
  const loaderData = useLoaderData()
  const [, setNav] = PageNavContainer.useContainer()
  const { appRouting } = useContext(RoutingContext)
  const loaderDataWithRouting = injectRouting(appRouting, loaderData)
  const [result] = useQuery({
    query: CurrentEnrolmentForLatestEpworthResult,
    variables: [],
    requestPolicy: `network-only`,
  })

  const { data, error } = result

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
      Header: OldAppHeader,
    })
  }, [setNav])

  return !data || error ? (
    <LoadOverlay />
  ) : (
    <HubEpworthQuizResultsPage
      content={loaderDataWithRouting.page.content}
      results={data.currentEnrolment.latestEpworthResult}
    />
  )
}

export default HubDbasQuizResultsModule
